import { riskColor, tok } from './risk'

/** Fleet × signal (or × module) heatmap on the risk arc. Cells fill their column;
 *  the value is shown in-cell for small grids. */
export function Heatmap({
  rows,
  grid,
  cols = ['M1', 'M2', 'M3', 'M4', 'M5', 'M6'],
  height = 190,
  padL = 76,
  maxWidth = 620,
  showValues = false,
}: {
  rows: string[]
  grid: number[][]
  cols?: string[]
  height?: number
  padL?: number
  maxWidth?: number
  showValues?: boolean
}) {
  const W = 440
  const H = height
  const padT = 18
  const gap = 4
  const cw = (W - padL - 6) / cols.length
  const ch = (H - padT - 6) / rows.length
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', maxWidth, height: 'auto' }}>
      {cols.map((c, j) => (
        <text
          key={c}
          x={padL + cw * j + cw / 2}
          y={padT - 6}
          textAnchor="middle"
          fontSize={9.5}
          fontFamily="var(--font-display)"
          fill={tok('--faint')}
        >
          {c}
        </text>
      ))}
      {rows.map((r, i) => (
        <text
          key={r}
          x={padL - 8}
          y={padT + ch * i + ch / 2 + 3.5}
          textAnchor="end"
          fontSize={10}
          fill={tok('--muted-foreground')}
        >
          {r}
        </text>
      ))}
      {grid.flatMap((row, i) =>
        row.map((v, j) => (
          <g key={`${i}-${j}`}>
            <rect
              x={padL + cw * j + gap / 2}
              y={padT + ch * i + gap / 2}
              width={cw - gap}
              height={ch - gap}
              rx={4}
              fill={riskColor(v)}
            />
            {showValues && (
              <text
                x={padL + cw * j + cw / 2}
                y={padT + ch * i + ch / 2 + 3.5}
                textAnchor="middle"
                fontSize={10.5}
                fontWeight={600}
                fontFamily="var(--font-display)"
                fill="#fff"
              >
                {Math.round(v)}
              </text>
            )}
          </g>
        )),
      )}
    </svg>
  )
}
